import * as React from 'react';
// UCItemコンポーネントをインポート
import UCItem from "../atoms/UCItem";
// MUIのコンポーネントをインポート
import { Box, Typography, Divider } from '@mui/material';
// UCListTypeをインポート
import { UCListType } from '../organisms/UCList';

// コンポーネントのプロパティ型の定義
type Props ={
  data: UCListType  // カテゴリーデータ
}

/** user コンテンツ一覧カテゴリ部品 */
const UCCategory = (props: Props) => {
  return (
    // カテゴリー全体のコンテナ
    <Box sx={{padding: '10px'}}>
      {/* カテゴリータイトルの表示 */}
      <Typography variant="h6">
        〇{props.data.category}
      </Typography>
      {/* カテゴリータイトルの下の区切り線 */}
      <Divider />
      {/* カテゴリー内の各アイテムを表示 */}
      {props.data.items.map((i, index) => 
        <UCItem key={index} data={i}/>
      )}
    </Box>
  );
}

export default UCCategory;